module.exports = __webpack_public_path__ + "static/media/servicio_logistica.cf3513e7.jpg";